import { GET_CATEGORIES, GET_CATEGORY } from "../rest-api/queries/category"

import {
  CREATE_CATEGORY,
  DELETE_CATEGORY,
  UPDATE_CATEGORY,
} from "../rest-api/mutations/category"
import { useMutation, useQuery } from "@tanstack/react-query"
export default function useCategory(params, id) {
  const categories = useQuery(["categories"], () => GET_CATEGORIES(params))
  const category = useQuery(["categories"], () => GET_CATEGORY(id))
  const createCategory = useMutation(CREATE_CATEGORY, {
    onSuccess: () => {
      categories.refetch()
    },
  })
  const updateCategory = useMutation(UPDATE_CATEGORY, {
    onSuccess: () => {
      categories.refetch()
    },
  })
  const deleteCategory = useMutation(DELETE_CATEGORY, {
    onSuccess: () => {
      categories.refetch()
    },
  })

  return {
    categories,
    category,
    createCategory,
    deleteCategory,
    updateCategory,
  }
}
